import { writable } from "svelte/store";

const plants = writable([
  {
    "plantId": "-4360259640222035586",
    "commonName": "Corn",
    "scientificName": "Zea mays",
    "tempLow": "55",
    "tempHigh": "95",
    "harvest": "75",
    "daysSow": "0",
    "germEnd": "10",
    "svg": "Corn.svg",
    "URL": "https://en.wikipedia.org/wiki/Maize"
  },
  {
    "plantId": "700119485825359714",
    "commonName": "Pea",
    "scientificName": "Pisum sativum",
    "tempLow": "40",
    "tempHigh": "80",
    "harvest": "65",
    "daysSow": "0",
    "germEnd": "10",
    "svg": "Pea.svg",
    "URL": "https://en.wikipedia.org/wiki/Pea"
  },
  {
    "plantId": "7243496257612484771",
    "commonName": "Leek",
    "scientificName": "Allium porrum",
    "tempLow": "40",
    "tempHigh": "80",
    "harvest": "120",
    "daysSow": "70",
    "germEnd": "12",
    "svg": "Leek.svg",
    "URL": "https://en.wikipedia.org/wiki/Leek"
  },
  {
    "plantId": "4651840539936356394",
    "commonName": "Cantaloupe",
    "scientificName": "Cucumis melo",
    "tempLow": "55",
    "tempHigh": "95",
    "harvest": "85",
    "daysSow": "0",
    "germEnd": "10",
    "svg": "Cantaloupe.svg",
    "URL": "https://en.wikipedia.org/wiki/Cantaloupe"
  },
  {
    "plantId": "4069522599651715316",
    "commonName": "Onion",
    "scientificName": "Allium cepa",
    "tempLow": "40",
    "tempHigh": "80",
    "harvest": "110",
    "daysSow": "84",
    "germEnd": "20",
    "svg": "Onion.svg",
    "URL": "https://en.wikipedia.org/wiki/Onion"
  },
  {
    "plantId": "3317392024211927600",
    "commonName": "Tomato",
    "scientificName": "Solanum lycopersicum",
    "tempLow": "55",
    "tempHigh": "95",
    "harvest": "65",
    "daysSow": "32",
    "germEnd": "10",
    "svg": "Tomato.svg",
    "URL": "https://en.wikipedia.org/wiki/Tomato"
  },
  {
    "plantId": "6084674957358144924",
    "commonName": "Potato",
    "scientificName": "Solanum tuberosum",
    "tempLow": "50",
    "tempHigh": "80",
    "harvest": "125",
    "daysSow": "28",
    "germEnd": "0",
    "svg": "Potato.svg",
    "URL": "https://en.wikipedia.org/wiki/Potato"
  },
  {
    "plantId": "-1452327664920181626",
    "commonName": "Pepper",
    "scientificName": "Capsicum annuum",
    "tempLow": "55",
    "tempHigh": "95",
    "harvest": "70",
    "daysSow": "39",
    "germEnd": "20",
    "svg": "Pepper.svg",
    "URL": "https://en.wikipedia.org/wiki/Bell_pepper"
  },
  {
    "plantId": "8966395072127027946",
    "commonName": "Carrot",
    "scientificName": "Daucus carota",
    "tempLow": "50",
    "tempHigh": "80",
    "harvest": "70",
    "daysSow": "0",
    "germEnd": "21",
    "svg": "Carrot.svg",
    "URL": "https://en.wikipedia.org/wiki/Carrot"
  },
  {
    "plantId": "-4095164293414183953",
    "commonName": "Radish",
    "scientificName": "Raphanus sativus",
    "tempLow": "40",
    "tempHigh": "80",
    "harvest": "30",
    "daysSow": "0",
    "germEnd": "7",
    "svg": "Radish.svg",
    "URL": "https://en.wikipedia.org/wiki/Radish"
  },
  {
    "plantId": "262644758805253510",
    "commonName": "Lettuce",
    "scientificName": "Lactuca sativa",
    "tempLow": "40",
    "tempHigh": "80",
    "harvest": "60",
    "daysSow": "45",
    "germEnd": "10",
    "svg": "Lettuce.svg",
    "URL": "https://en.wikipedia.org/wiki/Lettuce"
  },
  {
    "plantId": "-6690279405914198363",
    "commonName": "Spinach",
    "scientificName": "Spinacia oleracea",
    "tempLow": "40",
    "tempHigh": "80",
    "harvest": "40",
    "daysSow": "22",
    "germEnd": "10",
    "svg": "Spinach.svg",
    "URL": "https://en.wikipedia.org/wiki/Spinach"
  },
  {
    "plantId": "-6137866173690498356",
    "commonName": "Eggplant",
    "scientificName": "Solanum melongena",
    "tempLow": "55",
    "tempHigh": "95",
    "harvest": "60",
    "daysSow": "31",
    "germEnd": "12",
    "svg": "Eggplant.svg",
    "URL": "https://en.wikipedia.org/wiki/Eggplant"
  },
  {
    "plantId": "-7234723121193579423",
    "commonName": "Broccoli",
    "scientificName": "Brassica oleracea",
    "tempLow": "40",
    "tempHigh": "80",
    "harvest": "65",
    "daysSow": "52",
    "germEnd": "10",
    "svg": "Broccoli.svg",
    "URL": "https://en.wikipedia.org/wiki/Broccoli"
  },
  {
    "plantId": "-2882781183424417388",
    "commonName": "Cauliflower",
    "scientificName": "Brassica oleracea",
    "tempLow": "40",
    "tempHigh": "80",
    "harvest": "65",
    "daysSow": "52",
    "germEnd": "10",
    "svg": "Cauliflower.svg",
    "URL": "https://en.wikipedia.org/wiki/Cauliflower"
  },
  {
    "plantId": "4992248545757731715",
    "commonName": "Cucumber",
    "scientificName": "Cucumis sativus",
    "tempLow": "55",
    "tempHigh": "95",
    "harvest": "55",
    "daysSow": "7",
    "germEnd": "10",
    "svg": "Cucumber.svg",
    "URL": "https://en.wikipedia.org/wiki/Cucumber"
  },
    
]);

const customStore = {
  subscribe: plants.subscribe,
  setPlants: (items) => {
    plants.set(items);
  },
};

export default customStore;
